export const SMEs = [
  { name: 'SE100', label: 'SE100' },
  { name: 'SE110', label: 'SE110' },
  { name: 'SE120', label: 'SE120' },
  { name: 'SE130', label: 'SE130' },
  { name: 'SE140', label: 'SE140' },
  { name: 'SE230', label: 'SE230' },
  { name: 'SE240', label: 'SE240' },
  { name: 'SE250', label: 'SE250' },
  { name: 'SE300', label: 'SE300' },
  { name: 'SE310', label: 'SE310' },
  { name: 'SE320', label: 'SE320' },
  { name: 'SE330', label: 'SE330' },
  { name: 'SE350', label: 'SE350' },
  { name: 'SE400', label: 'SE400' },
  { name: 'SE420', label: 'SE420' },
  { name: 'SE430', label: 'SE430' },
  { name: 'SE440', label: 'SE440' },
  { name: 'SE450', label: 'SE450' },
  { name: 'SE540', label: 'SE540' },
  { name: 'SE600', label: 'SE600' },
  { name: 'SE610', label: 'SE610' },
  { name: 'SE620', label: 'SE620' },
  { name: 'SE700', label: 'SE700' },
  { name: 'SE710', label: 'SE710' },
  { name: 'SE720', label: 'SE720' },
  { name: 'SE730', label: 'SE730' },
];

export const ageIntervalStandard = ['GLASS', 'SWEDRES', 'FOHM'];

export const GLASS = ['<1', '1-4', '5-14', '15-24', '25-34', '35-44', '45-54', '55-64', '65-74', '75-84', '85-'];
export const SWEDRES = ['<1', '1-4', '5-19', '20-44', '45-64', '65-84', '85-'];
export const FOHM = [
  '<1',
  '1-4',
  '5-9',
  '10-14',
  '15-19',
  '20-24',
  '25-29',
  '30-39',
  '40-49',
  '50-59',
  '60-69',
  '70-79',
  '80-',
];

export const ageIntervalsByStandard = {
  GLASS: GLASS,
  SWEDRES: SWEDRES,
  FOHM: FOHM,
};

export const MIC_VALUES = [
  0.002, 0.004, 0.008, 0.016, 0.032, 0.064, 0.125, 0.25, 0.5, 1, 2, 4, 8, 16, 32, 64, 128, 256, 512, 1024,
];
